<template>
  <div class="relative min-h-screen md:flex">
    <MainMenu />
    <div
      class="flex-1 w-full absolute gray-background min-h-screen"
      :class="[iframe ? '' : 'md:max-h-screen md:overflow-x-scroll md:py-10 md:pl-28 md:pr-10']"
    >
      <router-view :key="`${$route.name}${$route.params.id ? `-${$route.params.id}` : ''}`" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters(["getCurrentUser", "getCurrentUserContext"])
  },
  mounted() {
    if (this.$route.query.iframe) {
      this.iframe = true
    }

    if (this.$route.name === 'dashboard_base') {
      this.$router.push({ name: "dashboard_forms"})
    }
  },
  data() {
    return {
      iframe: false
    }
  },
  methods: {}
}
</script>
